import { render, staticRenderFns } from "./BlogPostsMarketing.vue?vue&type=template&id=39666330&scoped=true&"
import script from "./BlogPostsMarketing.vue?vue&type=script&lang=ts&"
export * from "./BlogPostsMarketing.vue?vue&type=script&lang=ts&"
import style0 from "./BlogPostsMarketing.vue?vue&type=style&index=0&id=39666330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39666330",
  null
  
)

export default component.exports